import { render } from "./BakaAnakShow.vue?vue&type=template&id=2057ea8a"
import script from "./BakaAnakShow.vue?vue&type=script&lang=js"
export * from "./BakaAnakShow.vue?vue&type=script&lang=js"

import "./BakaAnakShow.vue?vue&type=style&index=0&id=2057ea8a&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__